export default {"src":"/_next/static/media/warning-icon.58e0d481.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};